"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SECURITY_SECTIONS = exports.SECURITY_MEASURES_DESCRIPTION = exports.SECURITY_MEASURES_TITLE = exports.SECURITY_MEASURES_VERSIONS = exports.SECURITY_MEASURES_VERSION_DATE = void 0;
exports.SECURITY_MEASURES_VERSION_DATE = '1 mars 2026';
exports.SECURITY_MEASURES_VERSIONS = [
    {
        date: exports.SECURITY_MEASURES_VERSION_DATE,
        fileName: 'security-measures.pdf',
        isCurrent: true,
    },
];
exports.SECURITY_MEASURES_TITLE = 'Mesures de sécurité';
exports.SECURITY_MEASURES_DESCRIPTION = 'Description des mesures de sécurité techniques et organisationnelles mises en œuvre (y compris toute certification pertinente) visant à garantir un niveau de sécurité approprié, compte tenu de la nature, de la portée, du contexte et de la finalité du traitement, ainsi que des risques pour les droits et libertés des personnes physiques.';
exports.SECURITY_SECTIONS = [
    {
        title: 'Contrôle d\u2019accès physique aux sites et installations utilisés pour les prestations',
        objective: 'Prévenir l\u2019accès non autorisé aux sites et installations utilisés pour/dans le(s) traitement(s) de données',
        items: [
            {
                text: 'Dispositif anti-intrusion (verrouillage des portes, alarmes anti-intrusion)',
                checked: false,
                level: 1,
            },
            {
                text: 'Alimentation électrique de secours garantie des dispositifs physiques de sécurité',
                checked: false,
                level: 1,
            },
            {
                text: 'Dispositif d\u2019authentification à l\u2019entrée des sites (badge, clé, etc.)',
                checked: false,
                level: 1,
            },
            {
                text: 'Procédure d\u2019octroi/retrait des dispositifs d\u2019authentification à l\u2019entrée des sites',
                checked: false,
                level: 1,
            },
            {
                text: 'Stockage des supports de sauvegarde dans un lieu sécurisé',
                checked: true,
                level: 1,
            },
            { text: 'Vidéosurveillance', checked: false, level: 1 },
            { text: 'Service de gardiennage 24/7', checked: false, level: 1 },
            {
                text: 'Terminaux mobiles rangés dans un lieu sécurisé en dehors des heures de travail',
                checked: false,
                level: 1,
            },
            {
                text: 'Modalités d\u2019accès spécifiques pour les visiteurs (registre, badge temporaire, etc.)',
                checked: false,
                level: 1,
            },
            { text: 'Certification des datacenters', checked: true, level: 1 },
            {
                text: 'Mesures de restriction d\u2019accès supplémentaires aux espaces techniques critiques',
                checked: false,
                level: 1,
            },
            { text: 'Salles fermées à clé', checked: false, level: 2 },
            { text: 'Vidéosurveillance avec/sans enregistrement', checked: false, level: 2 },
            {
                text: 'Badge avec habilitation spécifique justifié par un besoin professionnel légitime',
                checked: false,
                level: 2,
            },
            {
                text: 'Politique d\u2019accompagnement des visiteurs dans les locaux',
                checked: false,
                level: 1,
            },
            {
                text: 'Environnement de travail chez le prestataire dédié au client (zone dédiée) avec contrôles d\u2019accès spécifiques',
                checked: false,
                level: 1,
            },
            { text: 'Badge avec habilitation d\u2019accès spécifique', checked: false, level: 2 },
            { text: 'Journalisation de l\u2019activité des badges', checked: false, level: 2 },
            {
                text: 'Isolement (au sein d\u2019une zone dédiée) des collaborateurs travaillant sur des applications / sujets sensibles',
                checked: false,
                level: 2,
            },
        ],
    },
    {
        title: 'Contrôles d\u2019accès logique aux systèmes et outils utilisés pour les prestations',
        objective: 'Prévenir l\u2019accès non autorisé aux systèmes IT sur lesquels sont traitées les données',
        items: [
            { text: 'Journalisation des accès aux systèmes IT', checked: true, level: 1 },
            {
                text: 'Identification des utilisateurs via des comptes utilisateurs nominatifs',
                checked: true,
                level: 1,
            },
            {
                text: 'Limitation du nombre de tentatives d\u2019accès à un compte (blocage du compte utilisateur)',
                checked: true,
                level: 1,
            },
            {
                text: 'Politique robuste de mots de passe (utilisateurs/administrateurs)',
                checked: true,
                level: 1,
            },
            {
                text: 'Politique d\u2019accès aux systèmes IT avec procédure de gestion des habilitations et revue régulière',
                checked: true,
                level: 1,
            },
            {
                text: 'Accès aux systèmes IT uniquement après authentification double facteur',
                checked: false,
                level: 1,
            },
            {
                text: 'Sécurisation de l\u2019accès distant aux systèmes IT (VPN, authentification forte, etc.)',
                checked: true,
                level: 1,
            },
            {
                text: 'Sécurisation du réseau sans fil par le protocole WPA2 ou WPA2-PSK',
                checked: false,
                level: 1,
            },
            { text: 'Terminaux mobiles protégés par chiffrement', checked: false, level: 1 },
            {
                text: 'Verrouillage automatique des sessions en cas d\u2019inactivité',
                checked: true,
                level: 1,
            },
            {
                text: 'Mise à jour régulière (automatique ou manuelle) des antivirus et pare-feu',
                checked: true,
                level: 1,
            },
            {
                text: 'Installation des mises à jour critiques des systèmes d\u2019exploitation sans délai',
                checked: true,
                level: 1,
            },
            {
                text: 'Installation des mises à jour des applications en cas de faille critique',
                checked: true,
                level: 1,
            },
            {
                text: 'Procédure d\u2019oubli de mot de passe obligatoire et auditable',
                checked: true,
                level: 1,
            },
            {
                text: 'Console spécifique d\u2019administration des serveurs sécurisée',
                checked: true,
                level: 1,
            },
            { text: 'SIEM / SOC', checked: false, level: 1 },
            {
                text: 'Sécurité des interfaces inter-applications (authentification, chiffrement\u2026)',
                checked: true,
                level: 1,
            },
        ],
    },
    {
        title: 'Contrôle de l\u2019accès aux Données de l\u2019entreprise',
        objective: 'Prévenir tout accès et activité illicite/non autorisé(e) sur les données',
        items: [
            { text: 'Pseudonymisation', checked: false, level: 1 },
            {
                text: 'Accès restreint aux données aux seules personnes justifiant d\u2019un besoin opérationnel',
                checked: true,
                level: 1,
            },
            {
                text: 'Accès justifié par un ticket d\u2019assistance ouvert par le client',
                checked: false,
                level: 1,
            },
            { text: 'Enregistrement des connexions et accès aux données', checked: true, level: 1 },
            {
                text: 'Formalisation des habilitations d\u2019accès dans une politique',
                checked: true,
                level: 1,
            },
        ],
    },
    {
        title: 'Mesures relatives à la sécurité des transmissions de données',
        objective: 'Assurer une transmission sécurisée des données et prévenir toute transmission non autorisée',
        items: [
            {
                text: 'Chiffrement des données transmises par Internet (chiffrement des courriels, connexion sécurisée en transit par cryptage SSL)',
                checked: true,
                level: 1,
            },
            { text: 'Accès à distance via une connexion VPN', checked: true, level: 1 },
        ],
    },
    {
        title: 'Mesures relatives au contrôle de l\u2019intégrité des données',
        objective: 'Protéger les données contre toute altération et assurer la traçabilité de toute saisie, modification et suppression de données',
        items: [
            {
                text: 'Journalisation de l\u2019activité des administrateurs systèmes',
                checked: true,
                level: 1,
            },
            {
                text: 'Journalisation de l\u2019activité des utilisateurs des outils de traitement de données personnelles',
                checked: true,
                level: 1,
            },
            {
                text: 'Journaux collectés et monitorés par le Cyber SOC, avec scénarios suspects définis',
                checked: false,
                level: 1,
            },
            { text: 'Effacement des données sur les matériels mis au rebut', checked: false, level: 1 },
        ],
    },
    {
        title: 'Mesures relatives à la disponibilité de la solution et des données',
        objective: 'Protéger les données contre toute altération et assurer la traçabilité de toute saisie, modification et suppression de données',
        items: [
            {
                text: 'Sauvegarde régulière des données avec contrôle de réalisation et de vérification des sauvegardes',
                checked: true,
                level: 1,
            },
            {
                text: 'Procédure de restauration de sauvegarde avec test régulier',
                checked: false,
                level: 1,
            },
            {
                text: 'Stockage des supports de sauvegarde sur un site extérieur',
                checked: true,
                level: 1,
            },
            {
                text: 'Mesures de restriction d\u2019accès supplémentaires aux espaces techniques critiques',
                checked: false,
                level: 1,
            },
            { text: 'Salles fermées à clé / Alimentation UPS avec onduleurs', checked: false, level: 2 },
            { text: 'Détecteurs de fumée', checked: false, level: 2 },
            { text: 'Contrôle de la température', checked: false, level: 2 },
            {
                text: 'Politique d\u2019accompagnement des visiteurs dans les locaux',
                checked: false,
                level: 1,
            },
            {
                text: 'Utilisation conforme à l\u2019état de l\u2019art de solutions de protection des systèmes',
                checked: true,
                level: 1,
            },
            { text: 'Plan de continuité d\u2019activité avec test régulier', checked: false, level: 1 },
            { text: 'Plan de reprise d\u2019activité avec test régulier', checked: false, level: 1 },
        ],
    },
    {
        title: 'Mesures relatives à la séparation des données',
        objective: 'Séparer les données afin d\u2019éviter la propagation d\u2019un éventuel incident à d\u2019autres bases de données ou fichiers',
        items: [
            { text: 'Segmentation logique/physique des données', checked: true, level: 1 },
            { text: 'Sandboxing', checked: false, level: 1 },
        ],
    },
    {
        title: 'Mesures relatives à la sécurité des développements',
        objective: 'Éviter une violation de données personnelles en utilisant des données fictives pour effectuer les tests et développements d\u2019applications',
        items: [
            {
                text: 'Test de développements informatiques sur des données fictives ou anonymisées',
                checked: false,
                level: 1,
            },
            {
                text: 'Formation des développeurs aux principes de la protection des données par défaut et dès la conception et à la sécurité des environnements de développement et recette',
                checked: false,
                level: 1,
            },
            { text: 'Charte de la sécurité dans les développements', checked: false, level: 1 },
            { text: 'Revue de code', checked: true, level: 1 },
            {
                text: 'Environnements dédiés de développement et test / pré-production',
                checked: true,
                level: 1,
            },
            { text: 'Anonymisation des bases de données de test et recette', checked: false, level: 1 },
        ],
    },
    {
        title: 'Mesures organisationnelles',
        items: [
            {
                text: 'Procédure de test, d\u2019analyse et d\u2019évaluation de l\u2019efficacité des mesures techniques et organisationnelles (test d\u2019intrusion, scans de vulnérabilité internes et externes, etc.)',
                checked: false,
                level: 1,
            },
            {
                text: 'Procédure de gestion des incidents de sécurité et des violations de données personnelles',
                checked: true,
                level: 1,
            },
            { text: 'Politique de sécurité formalisée', checked: false, level: 1 },
            {
                text: 'Charte informatique avec une valeur contraignante pour les salariés',
                checked: false,
                level: 1,
            },
            { text: 'Sensibilisation des utilisateurs à la sécurité', checked: false, level: 1 },
            {
                text: 'Formation des collaborateurs amenés à travailler sur le(s) traitement(s) de données confié(s) au Prestataire',
                checked: false,
                level: 1,
            },
            {
                text: 'Évaluation régulière des Sous-traitants n-1 et de leurs mesures de sécurité',
                checked: false,
                level: 1,
            },
            { text: 'Plan d\u2019assurance sécurité', checked: false, level: 1 },
            { text: 'Charte informatique administrateur', checked: false, level: 1 },
            {
                text: 'Les Contrats avec des tiers incluent des clauses de sécurité, des SLA et les clauses adéquates en matière de protection des données personnelles.',
                checked: false,
                level: 1,
            },
        ],
    },
    {
        title: 'Mesures relatives à la sécurité applicative et système',
        items: [
            {
                text: 'Les composants applicatifs employés sont limités au strict nécessaire, recensés et sont mis à jour.',
                checked: true,
                level: 1,
            },
            {
                text: 'Dès que des données externes sont employées, un traitement rigoureux ou un fonctionnement par liste blanche est adopté.',
                checked: true,
                level: 1,
            },
            {
                text: 'Les inclusions de contenus tiers sont limitées au strict nécessaire. Des contrôles élémentaires sont effectués pour s\u2019assurer de la fiabilité du fournisseur de contenu.',
                checked: false,
                level: 1,
            },
            {
                text: 'Les données externes employées dans quelque partie que ce soit de la réponse envoyée au client ont fait l\u2019objet d\u2019un « échappement » adapté au contexte d\u2019interprétation et ont effectivement la forme attendue lorsque celle-ci est connue.',
                checked: true,
                level: 1,
            },
            {
                text: 'Les requêtes adressées à la base de données sont faites au moyen de requêtes préparées fortement typées ou par l\u2019intermédiaire d\u2019une couche d\u2019abstraction assurant le contrôle des paramètres.',
                checked: true,
                level: 1,
            },
            {
                text: 'Une matrice des flux de données précise est établie, tant en entrée qu\u2019en sortie, et son respect est imposé par un filtrage réseau.',
                checked: true,
                level: 1,
            },
            { text: 'Les traitements sont tous faits du côté du serveur.', checked: true, level: 1 },
            {
                text: 'Les redirections statiques sont favorisées plutôt que d\u2019employer des redirections contrôlées par des données externes (ex. CDN).',
                checked: true,
                level: 1,
            },
            {
                text: 'Pour les redirections dynamiques, un fonctionnement en liste blanche est adopté afin de vérifier que les URL visées soient légitimes.',
                checked: false,
                level: 1,
            },
            {
                text: 'Pour les actions sensibles, des mécanismes permettant de s\u2019assurer de la légitimité de la requête sont mis en place.',
                checked: true,
                level: 1,
            },
            {
                text: 'Le stockage des données issues du site internet se fait au sein de l\u2019Union européenne.',
                checked: true,
                level: 1,
            },
            {
                text: 'L\u2019accès à un "espace personnel" est soumis obligatoirement à authentification.',
                checked: true,
                level: 1,
            },
            {
                text: 'Le principe de moindre privilège doit être appliqué à l\u2019ensemble des éléments du système.',
                checked: true,
                level: 1,
            },
            {
                text: 'Les informations technologiques du site web accessibles par les visiteurs sont limitées.',
                checked: false,
                level: 1,
            },
            {
                text: 'Un mécanisme de filtrage réseau et d\u2019authentification spécifique est en place pour éviter l\u2019usurpation de l\u2019adresse de l\u2019administrateur.',
                checked: true,
                level: 1,
            },
            {
                text: 'Le protocole HTTPS est utilisé à chaque fois que c\u2019est possible.',
                checked: true,
                level: 1,
            },
            { text: 'Existence d\u2019un filtrage réseau par un pare-feu.', checked: true, level: 1 },
            {
                text: 'Les mots de passe ne sont pas stockés en clair mais dans une forme transformée par une fonction cryptographique non réversible conforme au Référentiel Général de Sécurité.',
                checked: true,
                level: 1,
            },
            {
                text: 'Une politique de journalisation précisant notamment les modalités et les durées de conservation des différents journaux ainsi que les méthodes d\u2019analyse et de corrélation des données produites est définie.',
                checked: true,
                level: 1,
            },
            {
                text: 'Les journaux sont transmis hors du serveur concerné pour éviter qu\u2019ils ne puissent être altérés de manière rétroactive par l\u2019attaquant.',
                checked: true,
                level: 1,
            },
        ],
    },
];
//# sourceMappingURL=securityMeasuresContent.js.map